import { Component, Output, EventEmitter } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { FunctionsService } from 'src/app/services/functions.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'src/app/app.constants';

@Component({
  selector: 'app-reassign-alert',
  templateUrl: './reassign-alert.component.html',
  styleUrls: ['./reassign-alert.component.css'],
  providers: [NgxSpinnerService]
})
export class ReassignAlertComponent {
  alertId:any;
  attendedByName:any;
  config = {
    displayKey: 'name', // if objects array passed which key to be displayed defaults to description
    placeholder:this.translate.instant('general.select'), // text to be displayed when no item is selected defaults to Select,
    searchPlaceholder:this.translate.instant('general.search'),
    noResultsFound:this.translate.instant('general.no_results_found'),
    search: true,
    limitTo: 5
  };
  options:any;
  selectedUser = 0;
  prevAttendedBy:any;
  userArray:any = [];
  @Output() action = new EventEmitter();

  constructor(private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private translate: TranslateService,
    public functionsService:FunctionsService) { 
  }

  getPossibleAttendees(alertId) {
      this.alertId = alertId;
      this.spinner.show();
      this.apiService.getStatus(alertId).subscribe(
        data => {
            this.attendedByName = data["attendedByName"];
            //Get attended by id
            this.apiService.getPossibleAttendees(alertId).subscribe(
                resp => {
                    let jsonString = JSON.stringify(resp);
                    let jsonObject = JSON.parse(jsonString);
                    let name = "";
                    for(var i=0; i<jsonObject.length; i++){
                        name = jsonObject[i].profileFirstName+" "+jsonObject[i].profileLastName+" - "+this.translate.instant(jsonObject[i].role);
                    
                        this.userArray.push(
                            {
                                'id':jsonObject[i].id,
                                'index': i,
                                'name': name
                            }
                        );
                    }
                    this.options = this.userArray;
                    
                    this.spinner.hide();
                },
                error => {
                    this.spinner.hide();
                }
            );
        },
        error => {
            this.spinner.hide();
        }
      )
  }
  changeValue($event: any) {
    this.selectedUser = $event["value"]?$event["value"]["id"]:0;
    this.removeError();
  }
  
  reassignAlert() {
    if(this.selectedUser==0){
      this.showError();
      return;
    }
    this.spinner.show();
      this.apiService.reassignAlert({"AlertId":this.alertId,"ReassignedTo":this.selectedUser, "PrevAttendedBy": this.prevAttendedBy}).subscribe(
        data => {
            this.activeModal.close(data);
            this.spinner.hide();
        },
        error => { this.spinner.hide(); }
    );
  }
  showError(){
      let divElement = document.getElementsByClassName("ngx-dropdown-container");
      let border = divElement.item(0) as HTMLElement;
      border.style.cssText = "border:1px solid #dc3545;";
      document.getElementById("err").innerText = this.translate.instant("general.required_field");
  }
  removeError(){
    let divElement = document.getElementsByClassName("ngx-dropdown-container");
      let border = divElement.item(0) as HTMLElement;
      if(this.selectedUser == 0){border.style.removeProperty("border");}else{border.style.border = "1px solid #28a745"};
      document.getElementById("err").innerText = "";
  }
}
